import http from "../http-common.js";

export default {
    getAllJobOpenings() {
        return http.get("/employee_referral/api/job_openings").then(res => {
            return res;
        });
    },
};
